export const YARDI_PLATFORM_TYPE = {
  ORACLE: "ORACLE",
  SQL_SERVER: "SQL_SERVER",
};
